module.exports = {"TXTWCL_Suggested_amounts":{"id":"TXTWCL_Suggested_amounts","defaultMessage":"Montants suggérés","track":"Suggested amounts"}}